// extracted by mini-css-extract-plugin
export default {"modal":"Wr","topline":"Xr","img":"Yr","textcontents":"Zr","heading":"as","copy":"bs","link":"cs","close":"es","modalinner":"fs","container":"gs"};
    if(module.hot) {
      // 1715188229679
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  